import { Styles, StyleSheet } from '@react-pdf/renderer';

// shared styles for pdfs
export const sharedStyles = StyleSheet.create({
	darkGrey: {
		color: '#757575',
	},
	body: {
		padding: '52 24 64',
		fontFamily: 'Plus Jakarta Sans',
		fontSize: 10,
		fontWeight: 'light',
	},
	header: {
		position: 'absolute',
		top: 24,
		left: 24,
		right: 24,
	},
	documentName: {
		position: 'absolute',
		top: 24,
		left: 24,
	},
	pageNumber: {
		position: 'absolute',
		bottom: 24,
		right: 24,
	},
	createdModified: {
		position: 'absolute',
		bottom: 24,
		left: 24,
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	planHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingBottom: 16,
		borderBottom: '1px solid #E3E3E3',
		marginBottom: 12,
	},
	littleDot: {
		width: 4,
		height: 4,
		borderRadius: 2,
		backgroundColor: '#757575',
		lineHeight: 12,
	},
});

// styles for requirements fulfilment check pdf
export const RFCStyles: Styles = StyleSheet.create({
	programStructureAndUnitCountWrapper: {
		display: 'flex',
		flexDirection: 'row',
		gap: 12,
		justifyContent: 'space-between',
	},
	programStructureAndUnitCount: {
		width: '100%',
		border: '1px solid #E3E3E3',
		borderRadius: 8,
		padding: 12,
	},
	programStructure: {
		width: '100%',
		border: '1px solid #E3E3E3',
		borderRadius: 8,
		padding: 12,
	},
	unitCount: {
		width: '100%',
		border: '1px solid #E3E3E3',
		borderRadius: 8,
		padding: 12,
	},
	unitSelectItem: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
	},
});
